import { Card, CardContent, Collapse, Container, makeStyles, Paper, Typography, useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import React, { createRef } from 'react';
import Googleplay from '../img/Googleplay.png'
import ITunesStore from '../img/iTunes_Store.png'
import { BiDna } from 'react-icons/bi';
import { IoRocketOutline } from 'react-icons/io5';
import { AiOutlineFileProtect } from 'react-icons/ai'
import Cyberport from '../img/cyberport-removebg-preview.png'
import HKUST from '../img/HKUST-removebg-preview.png'
import Jumpstarter from '../img/jumpStarter-removebg-preview.png'
import FinTechAwards from '../img/FinTechAwards.png'
import HealthProtectionSvg from '../img/HealthProtection.svg'
import { BiCommentDots } from 'react-icons/bi'
import { BsBook } from 'react-icons/bs'
import { RiShieldCrossLine } from 'react-icons/ri'
import { HiOutlineLightBulb } from 'react-icons/hi'
import AppView from '../img/appView.png'
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { withNamespaces } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  element1Grid: {
    paddingTop: 100,
    [theme.breakpoints.down('sm')]: {
      paddingTop: 0,
    },
  },
  element1Title: {
    [theme.breakpoints.up('sm')]: {
      fontSize: "3.5vw",
    },
    lineHeight: 1.0,
    fontSize: 25,
    fontWeight: "bold"
  },
  element1Title2: {
    [theme.breakpoints.down('xs')]: {
      paddingBottom: 20
    },
  },
  element1Content: {
    [theme.breakpoints.up('sm')]: {
      fontSize: "2.2vw",
    },
    fontSize: 20,
  },
  ptVw2: {
    paddingTop: "2vw"
  },
  mt40: {
    marginTop: 40
  },
  title: {
    fontSize: 30,
    fontWeight: "bold",
    lineHeight: 1.0,
    [theme.breakpoints.down('sm')]: {
      fontSize: 25,
    },
  },
  content1: {
    textAlign: "center",
    fontSize: 30,
  },
  content2: {
    fontSize: 20,
    [theme.breakpoints.down('sm')]: {
      fontSize: 15,
    },
  },
  content3: {
    fontSize: 20,
  },
  shader: {
    backgroundColor: '#F2F2F2'
  },
  textAlignCenter: {
    textAlign: "center"
  },
  textAlignJustify: {
    textAlign: 'justify'
  },
  button: {
    padding: 15,
    paddingLeft: 40,
    paddingRight: 40,
    borderRadius: 30,
    fontWeight: "bold",
    color: "white",
    textTransform: "none",
    fontSize: 17,
    [theme.breakpoints.down('sm')]: {
      padding: 10,
      paddingLeft: 30,
      paddingRight: 30,
      borderRadius: 30,
    },
  },

  stepCardStyle: {
    width: 300,
    textAlign: "center"
  },
  redText: {
    color: "red"
  },
  p20: {
    paddingLeft: 20,
    paddingRight: 20
  },
  media: {
    height: "50%",
  },
  mediaImgWithoutPadding: {
    height: "125%",
  },
  mediaImg50per: {
    height: "50%",
  },
  mediaImg70per: {
    height: "70%",
  },
  leftTopBox: {
    borderRadius: 30,
    borderBottomRightRadius: 0,
  },
  rightTopBox: {
    borderRadius: 30,
    borderBottomLeftRadius: 0,
  },
  leftBottomBox: {
    borderRadius: 30,
    borderTopRightRadius: 0,
  },
  rightBottomBox: {
    borderRadius: 30,
    borderTopLeftRadius: 0,
  },
  boxAnimationGoDown: {
    top: 20,
    transition: theme.transitions.create(
      ['top'],
      { duration: 500 }
    ),
  },
  boxAnimationGoBack: {
    top: 0,
    transition: theme.transitions.create(
      ['top'],
      { duration: 500 }
    ),
  },
  card: {
    backgroundColor: "#cfcfcf",
    borderRadius: 30,
    minWidth: 200,
    minHeight: 400,
    transition: theme.transitions.create(
      ['background-color', 'min-width'],
      { duration: 500 }
    ),
    '&:hover': {
      cursor: 'pointer',
    }
  },
  tappedCard: {
    minWidth: 400,
    backgroundColor: theme.palette.primary.main,
    transition: theme.transitions.create(
      ['background-color', 'min-width'],
      { duration: 500 }
    ),
  },
  rootMediaCard: {
    height: 300,
    backgroundColor: "#F2F2F2"
  },
  textColorWhite: {
    color: "white"
  },
  cardTextBeforeTapped: {
    fontSize: 40,
    fontWeight: "bold",
  },
  disappear: {
    fontSize: 50,
    color: theme.palette.primary.main,
    transition: theme.transitions.create(
      ['color'],
      { duration: 500 }
    ),
  },
  appear: {
    fontSize: 50,
    color: "white",
    transition: theme.transitions.create(
      ['color'],
      { duration: 500 }
    ),
  },
  displayFlex: {
    display: "flex"
  },
  width150: {
    width: 150
  },
  phContent: {
    [theme.breakpoints.down("md")]: {
      textAlign: "center"
    },
  },
  howItWorksGrid: {
    paddingLeft: 40,
  },
  howItWorksCardTitle: {
    fontSize: 30,
    fontWeight: "bold"
  },
  HowItWorksCardcontent: {

  },
  paper: {
    padding: '6px 16px',
  },
  oppositeContent: {
    // TODO: adjust this value accordingly
    width: 100,
    paddingLeft: 20,
    flex: 0.2
  },
  timelineContent: {
    color: "red",
    fontWeight: "bold",
    paddingTop: 20
  },
  timelinePaper: {
    padding: '6px 16px',
    minHeight: 180
  },
  howItWorksBorder: {
    borderWidth: 10,
    borderStyle: 'solid',
    borderColor: "red",
    marginBottom: 20,
  },
  whyMyLifeContent: {
    fontSize: "1.2vw",
    [theme.breakpoints.down("sm")]: {
      fontSize: 12,
    }
  },
  whyMyLiftBox: {
    marginLeft: 20,
    marginRight: 20,
  },
  platformTitle: {
    paddingTop: 10,
    paddingBottom: 10
  },
  maxWidth700: {
    maxWidth: 700
  }

}));

function HomePage({t}) {
  const classes = useStyles();
  const theme = useTheme();

  const timelineRef = createRef()

  const [isTimelineOpened, setIsTimelineOpened] = React.useState(false);

  const handleTimelineOpenedChange = () => {
    setIsTimelineOpened(!isTimelineOpened)
  };

  let isSmUp = useMediaQuery(theme.breakpoints.up('sm'));

  const HowItWorksCard = ({ Icon, title, content }) => {
    return (
      <Grid container item md={3} sm={6} xs={12} style={isSmUp ? { marginTop: 40, marginBottom: 40 } : null} justify="center">
        <Grid item>
          {React.createElement(
            Icon,
            { size: 100 },
          )}
          <Box p={1} />
          <Typography color="primary" className={classes.title}>
            {title}
          </Typography>
          <Box p={1} />
          <Typography>
            {content}
          </Typography>
        </Grid>
      </Grid>
    )
  }

  const platformBlock = (Icon, title, content) => {
    return (
      <Grid item md={4} xs={12} container className={classes.ptVw2} style={{ paddingTop: 70 }}>
        <Grid item container justify="center">
          {React.createElement(
            Icon,
            { size: 80 },
          )}
        </Grid>
        <Grid container justify="center" className={classes.platformTitle}>
          <Typography className={`${classes.title} ${classes.textAlignCenter}`} color="primary">
            {title}
          </Typography>
        </Grid>
        <Grid item container justify="center">
          <Typography className={`${classes.content2} ${classes.phContent} ${classes.textAlignCenter}`}>
            {content}
          </Typography>
        </Grid>
      </Grid>
    )
  }

  const CoverImage = () => {
    return (
      <Grid item sm={5} xs={12}>
        <img style={{ width: "100%" }} src={AppView} />
      </Grid>
    )
  }

  return (
    <Grid>
      {/* <Box p={10} className={classes.shader} /> */}
      <Grid style={useMediaQuery(theme.breakpoints.up('md')) ? { position: "relative", bottom: 100 } : null}>
        <Grid container className={`${classes.shader}`}>
          <Grid container item>  
            <Grid>
            {!isSmUp &&
              <img 
              style={{
                width: "100%",
              }} 
              src={AppView} />
            }
            </Grid>
            <Grid item sm={2} xs={1} />
            <Grid container item sm={5} xs={10} alignContent="flex-end" className={classes.element1Grid}>
              <Grid item xs={12}>
                <Typography className={classes.element1Title}>
                {t("new-era-of")}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography className={`${classes.element1Title} ${classes.element1Title2}`} color="primary">
                {t("insurance-planning")}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography className={`${classes.element1Content} ${classes.ptVw2}`}>
                {t("smart-planning")}
                </Typography>
              </Grid>
              {isSmUp
                ?
                <Grid item container spacing={2} className={classes.ptVw2} xs={12}>
                  <Grid item xs={4} style={{ paddingBottom: 20 }}>
                    <img src={ITunesStore} style={{ width: "100%" }} />
                  </Grid>
                  <Grid item xs={4} style={{ paddingBottom: 20, paddingLeft: 20 }}>
                    <img src={Googleplay} style={{ width: "100%" }} />
                  </Grid>
                </Grid>
                :
                <Grid item container spacing={2} className={classes.ptVw2} xs={12}>
                  <Grid item xs={5} style={{ paddingBottom: 20 }}>
                    <img src={ITunesStore} style={{ width: "100%" }} />
                  </Grid>
                  <Grid item xs={5}>
                    <img src={Googleplay} style={{ width: "100%" }} />
                  </Grid>
                </Grid>
              }
            </Grid>
            {isSmUp &&
              <CoverImage />
            }
          </Grid>
        </Grid>
        {isSmUp ? null : <Box p={5} className={classes.shader} />}
        {isSmUp ? <svg width="100%" height="100%" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 1440 70" enableBackground="new 0 0 1440 70" xmlSpace="preserve" preserveAspectRatio="none">
          <path fill="#F2F2F2" d="M1440,0.01c-109,41.11-396.34,70-724.2,70C388.94,70,109.67,40.93,0,0h1440V0.01z"></path>
        </svg> : null}

      </Grid>

      {!isSmUp && <Box p={3} />}

      <Grid>
        <Container>
          <Grid container item xs={12} direction="column">
            <Grid container item className={classes.textAlignJustify} justify="center" direction="column">
              <Typography className={`${classes.title} ${classes.textAlignCenter}`} color="primary">
              {t("smart-protection")}
              </Typography>
              <Grid container item xs={12} justify="center">
                <Typography className={`${classes.content2} ${classes.ptVw2} ${classes.maxWidth700} ${classes.textAlignJustify}`}>
                {t("myLife-platform-combines")}
                </Typography>
              </Grid>
            </Grid>
            <Grid container justify="center">
              <Button variant="contained" color="primary" className={`${classes.button} ${classes.mt40}`} onClick={handleTimelineOpenedChange}>{t('learn-more')}</Button>
            </Grid>
            <Grid container item xs={12} justify="center">
              <Collapse in={isTimelineOpened} ref={timelineRef}>
                <Box bgcolor="#C4C4C4" style={{ borderRadius: 60, maxWidth: 700, marginTop: 40 }}>
                  <Grid container alignItems="stretch" spacing={3} style={{ padding: 40 }}>

                    <Paper className={classes.timelinePaper}>
                      <Typography className={classes.timelineContent}>
                      {t("DNA")}
                      </Typography>
                      <Typography>
                      {t("third-party")}
                      </Typography>
                      <Typography className={classes.timelineContent}>
                      {t("AI")}
                      </Typography>
                      <Typography >
                      {t("the-dna-report")}
                      </Typography>
                      <Typography className={classes.timelineContent}>
                      {t("Data Secure")}
                      </Typography>
                      <Typography >
                      {t("client's-personal")}
                      </Typography>
                    </Paper>
                  </Grid>
                </Box>
              </Collapse>
            </Grid>
          </Grid>

        </Container>
      </Grid>

      <Box p={6} />
      <Container>
        <Grid container item justify="center" alignItems="center" direction="column">
          <Grid item className={classes.textAlignCenter}>
            <Typography className={classes.content2} color="primary">
            {t("how-it-works")}
            </Typography>
            <Typography style={{ display: 'inline-block' }} className={`${classes.title}`}>
            {t("A")}
              <span style={{ color: theme.palette.primary.main }}>
              {t("customer-journey")}
              </span>
              {t("to-a-max-protection")}
            </Typography>
          </Grid>
          <Box p={5} />
          <Grid container item spacing={10} xs={12} className={classes.ptVw2} className={`${classes.howItWorksBorder} ${classes.textAlignCenter}`}>
            <HowItWorksCard Icon={HiOutlineLightBulb} title={t("aware")} content={t("aware-txt")} />
            <HowItWorksCard Icon={BiCommentDots} title={t("recommend")} content={t("recommends-txt")} />
            <HowItWorksCard Icon={BsBook} title={t("educate")} content={t("educate-txt")} />
            <HowItWorksCard Icon={RiShieldCrossLine} title={t("application")} content={t("application-txt")} />
          </Grid>

          <Box p={3} />
        </Grid>
      </Container>


      <Box p={6} />

      <Grid container item xs={12} alignItems="center" justify="center" direction="column">

        <Grid item>
          <Typography className={`${classes.title} ${classes.textAlignCenter}`}>
          {t("why-myLife-platform")} 
          </Typography>
        </Grid>
        <Box p={4} />
        <Grid item container direction="row" alignItems="center" justify="center">
          <Grid md={6} xs={12} container item alignItems="center">
            <img
              style={{
                width: "60%",
                marginLeft: "auto",
                marginRight: "auto",
                display: "block"
              }}
              src={HealthProtectionSvg}
            />
          </Grid>
          <Grid md={6} xs={12} item container direction="column" spacing={3}>
            <Grid container item justify="flex-start">
              <Box
                bgcolor="#F2F2F2"
                p={2}
                className={`${classes.rightTopBox} ${classes.whyMyLiftBox}`}
              >
                <Typography className={classes.whyMyLifeContent}>
                {t("insurance-too-hard")} 
                </Typography>
              </Box>
            </Grid>
            <Grid container item justify="flex-end">
              <Box
                bgcolor="#F2F2F2"
                p={2}
                className={`${classes.rightTopBox} ${classes.whyMyLiftBox}`}
              >
                <Typography className={classes.whyMyLifeContent}>
                {t("aggressive-agent")} 
                </Typography>
              </Box>
            </Grid>
            <Grid container item justify="flex-start">
              <Box
                bgcolor="#F2F2F2"
                p={2}
                className={`${classes.rightBottomBox} ${classes.whyMyLiftBox}`}
              >
                <Typography className={classes.whyMyLifeContent}>
                {t("no-detail-info")} 
                </Typography>
              </Box>
            </Grid>
            <Grid container item justify="flex-end">
              <Box
                bgcolor="#F2F2F2"
                p={2}
                className={`${classes.rightBottomBox} ${classes.whyMyLiftBox}`}
              >
                <Typography className={classes.whyMyLifeContent}>
                {t("no-predictive-advise")} 
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>


      <Box p={6} />
      <Grid container direction="column" justify="center" alignItems="center" >
        <Grid container item justify="center">
          <Typography className={`${classes.title} ${classes.textAlignCenter}`}>
          {t("platform-highlight")} 
          </Typography>
        </Grid>
        <Container className={classes.ptVw2}>
          <Grid item container spacing={isSmUp ? 10 : 0} justify="center" alignItems="flex-start">
            {platformBlock(BiDna, t("personalize-experience") , t("personalize-experience-txt"))}
            {platformBlock(IoRocketOutline, t("hassle-free"), t("hassle-free-txt"))}
            {platformBlock(AiOutlineFileProtect, t("fully-licensed"), t("fully-licensed-txt"))}
          </Grid>
        </Container>
        <Box p={10} />
        <Container>
          <Grid container direction="column" justify="center" alignItems="center" >
            <Grid container item justify="center">
              <Typography className={`${classes.title} ${classes.textAlignCenter}`}>
                {t("awards&recognition")}
              </Typography>
            </Grid>
            <Box p={5} />
            <Grid container item spacing={3}>
              <Grid item md={3} sm={6} xs={12}>
                <Card className={classes.rootMediaCard}>
                  <Grid container justify="center" alignItems="flex-start" className={classes.media}>
                    <img src={Jumpstarter} className={classes.mediaImgWithoutPadding} />
                  </Grid>
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="h2" align="center">
                    {t("alibaba")}
                      </Typography>
                    <Typography inline="true" variant="body1" color="textSecondary" component="p" align="center">
                    {t("alibaba-title")}
                    </Typography>
                    <Typography inline="true" variant="body1" color="textSecondary" component="p" align="center">
                    {t("alibaba-content")}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <Card className={classes.rootMediaCard}>
                  <Grid container justify="center" alignItems="center" className={classes.media}>
                    <img src={Cyberport} className={classes.mediaImgWithoutPadding} />
                  </Grid>
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="h2" align="center">
                    {t("cyberport")}
                      </Typography>
                    <Typography variant="body1" color="textSecondary" component="p" align="center">
                    {t("cyberport-title")}
                      </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <Card className={classes.rootMediaCard}>
                  <Grid container justify="center" alignItems="center" className={classes.media}>
                    <img src={HKUST} className={classes.mediaImg70per}>
                    </img>
                  </Grid>
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="h2" align="center">
                    {t("hkust")}
                      </Typography>
                    <Typography variant="body1" color="textSecondary" component="p" align="center">
                    {t("hkust-title")}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <Card className={classes.rootMediaCard}>
                  <Grid container justify="center" alignItems="center" className={classes.media}>
                    <img src={FinTechAwards} className={classes.mediaImg50per}>
                    </img>
                  </Grid>
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="h2" align="center">
                    {t("etnet")}
                      </Typography>
                    <Typography variant="body1" color="textSecondary" component="p" align="center">
                    {t("etnet-title")}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Grid>

        </Container>
        <Box p={10} />
        <svg width="100%" height="100%" id="Layer_1" x="0px" y="0px" viewBox="0 0 1440 70" enableBackground="new 0 0 1440 70" xmlSpace="preserve" preserveAspectRatio="none"><path fill="#000000" d="M1440,70C1331,28.89,1043.66,0,715.8,0C388.94,0,109.67,29.08,0,70H1440z"></path>
        </svg>
      </Grid>
    </Grid >
  );
}

export default withNamespaces()(HomePage);